var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useRef, useState } from 'react';
import Button from '@storeblocks/button';
import { SystemIcon } from '@storeblocks/icon';
import { getText } from '@storebrand-digital/fms-translations';
import { InlineAlertStyled, LabelWrap, List, Row } from './styled';
function FileList(_a) {
    var files = _a.files, onRemoveFile = _a.onRemoveFile, setIsValid = _a.setIsValid, isRedBackground = _a.isRedBackground;
    var endOfListRef = useRef(null);
    var _b = useState(files), prevFiles = _b[0], setPrevFiles = _b[1];
    var fileNamesSize = 0;
    var filesRegex = /^.*\.(jpg|jpeg|JPG|png|PNG|pdf|PDF|txt|doc|docx|csv|xlsx)$/;
    var fileTypeValid = true;
    files.forEach(function (file) {
        fileNamesSize = fileNamesSize + 25 + file.name.length;
        if (!filesRegex.test(file.name)) {
            fileTypeValid = false;
        }
    });
    var addCommas = files.length - 1;
    var fileNamesValid = fileNamesSize + addCommas <= 255;
    var fileSizeValid = files.filter(function (file) { return file.size > 5 * 1024 * 1024; }).length === 0;
    useEffect(function () {
        setIsValid(files.length <= 5 && fileNamesValid && fileSizeValid && fileTypeValid);
        setPrevFiles(files);
        if (prevFiles.length <= files.length) {
            endOfListRef.current.scrollIntoView();
        }
    }, [files]);
    function onRemove(index) {
        onRemoveFile(__spreadArray(__spreadArray([], files.slice(0, index), true), files.slice(index + 1), true));
    }
    return (React.createElement(List, null,
        files.map(function (file, index) { return (
        // eslint-disable-next-line
        React.createElement(Row, { key: "".concat(file.name, "-").concat(index) },
            React.createElement(LabelWrap, null,
                React.createElement(SystemIcon, { name: "attachment", size: 16 }),
                React.createElement("span", { "data-hj-suppress": true }, file.name)),
            React.createElement(Button, { variant: "icon", type: "button", iconRight: "close", color: "on-surface", onClick: function () { return onRemove(index); } }))); }),
        React.createElement("span", { ref: endOfListRef }),
        files.length > 5 && (React.createElement(InlineAlertStyled, { title: getText('filelist.validation.length'), variant: "error", isRedBackground: isRedBackground })),
        !fileNamesValid && (React.createElement(InlineAlertStyled, { title: getText('filelist.validation.name'), variant: "error", isRedBackground: isRedBackground })),
        !fileSizeValid && (React.createElement(InlineAlertStyled, { title: getText('filelist.validation.size'), variant: "error", isRedBackground: isRedBackground })),
        !fileTypeValid && (React.createElement(InlineAlertStyled, { title: getText('filelist.validation.type'), variant: "error", isRedBackground: isRedBackground }))));
}
export default FileList;
